import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { DEFAULT_OBJECT_CATEGORY } from '@/components/common/constants.js'
import axios from 'axios'
// var axios = window.axios
Vue.use(Vuex)
const state = {
  // recommendedCourses: [],
  mostWatchedLOs: [], // libraryCards
  newLOs: [], // newVideoCards
  allCourses: [], // trendingCourses
  // allLOs: []
  recommendedItems: [] // los n cos to be recommended to userd
}
const getters = {
  /* getRecommendedCoursesData: function (state) {
    return state.recommendedCourses
  }, */
  // return data for recommendation
  getrecommendedItems: function (state) {
    return state.recommendedItems
  },
  // return data for libraryCards
  getMostWatchedLos: function (state) {
    return state.mostWatchedLOs
  },
  // return data for newVideoCards
  getNewLos: function (state) {
    return state.newLOs
  },
  // return data for trendingCourses
  getAllCOs: function (state) {
    return state.allCourses
  }
  // unknown
  // getAllLOs: function (state) {
  //   return state.allLOs
  // }
}
const actions = {
  // rcommended courser
  // called from recommendtaion for fetching
  fetchRecommendedItemsFromDB (context, data) {
    // alert(JSON.stringify(data))
    return new Promise((resolve, reject) => {
      axios
        .post('r/getContentBasedRecommendation', data
        )
        .then(response => {
          context.commit('setRecommendedItems', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  },
  // trendingCourses
  // called from trendingCourses for fetching
  fetchAllCOsFromDb (context) {
    return new Promise((resolve, reject) => {
      var objectCategory = ''
      // console.log('co', JSON.stringify(context.getters.getProfileDetails))
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || Object.keys(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = DEFAULT_OBJECT_CATEGORY
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails)
        // console.log(objectCategory)
      }
      axios
        .get('o/getTrendingCourses', {headers: {'contentCategory': objectCategory}})
        .then(response => {
          context.commit('setAllCosStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  },
  // called from trendingCourses for reseting
  clearAllCosFromStore (context) {
    context.commit('clearAllCosStoreData', [])
  },
  // libraryCards
  // called from libraryCards for fetching
  fetchMostWatchedLosFromDb (context) {
    return new Promise((resolve, reject) => {
      var objectCategory = ''
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || Object.keys(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = DEFAULT_OBJECT_CATEGORY
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails)
        // console.log(objectCategory)
      }
      axios
        .get('o/getmostwatchedlos', {headers: {'contentCategory': objectCategory}})
        .then(response => {
          context.commit('setMostWatchedLosStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  },
  // called from libraryCards for reseting
  clearMostWatchedLosFromStore (context) {
    context.commit('clearMostWatchedLosStoreData', [])
  },
  // newVideoCards
  // called from newVideoCards for fetching
  fetchNewLosFromDb (context) {
    return new Promise((resolve, reject) => {
      var objectCategory = ''
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || Object.keys(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        objectCategory = DEFAULT_OBJECT_CATEGORY
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails)
      }
      axios
        .get('o/newlolist', {headers: {'contentCategory': objectCategory}})
        .then(response => {
          context.commit('setNewLosStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  },
  // called from newVideoCards for reseting
  clearNewLosFromStore (context) {
    context.commit('clearNewLosStoreData', [])
  }
  // unknown
  /* fetchAllLOsFromDb (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('o/getalllos'
        )
        .then(response => {
          context.commit('setAllLOsStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  }, */
  // unknown
  /* fetchRecommendedCoursesFromDb (context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('r/getrecommendation', {
          'profileId': data
        })
        .then(response => {
          context.commit('setRecommendedCoursesStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  } */
}
const mutations = {
   // recommendation courses
  // used for setting recommendation
  setRecommendedItems (state, data) {
    if (data === null) {
      state.recommendedItems = []
    } else {
      state.recommendedItems = data
    }
  },
  // used for resetting recommendation
  clearRecommendedItems (state) {
    state.recommendedItems = []
  },
  // trending courses
  // used for setting trendingCourses
  setAllCosStoreData (state, data) {
    if (data === null) {
      state.allCourses = []
    } else {
      state.allCourses = data
    }
  },
  // used for resetting trendingCourses
  clearAllCosStoreData (state) {
    state.allCourses = []
  },
  // libraryCards
  // used for setting libraryCards
  setMostWatchedLosStoreData (state, data) {
    if (data === null) {
      state.mostWatchedLOs = []
    } else {
      state.mostWatchedLOs = data
    }
  },
  // used for resetting libraryCards
  clearMostWatchedLosStoreData (state) {
    state.mostWatchedLOs = []
  },
  // newVideoCards
  // used for setting newVideoCards
  setNewLosStoreData (state, data) {
    if (data === null) {
      state.newLOs = []
    } else {
      state.newLOs = data
    }
  },
  // used for resetting newVideoCards
  clearNewLosStoreData (state) {
    state.newLOs = []
  }
  // unknown
  /* setAllLOsStoreData (state, data) {
    if (data === null) {
      state.allLOs = []
    } else {
      state.allLOs = data
    }
  }, */
  // unknown
  // clearAllLOsStoreData (state) {
  //   state.allLOs = []
  // },
  // not in use
  /* setRecommendedCoursesStoreData (state, data) {
    if (data === null) {
      state.recommendedCourses = []
    } else {
      state.recommendedCourses = data
    }
  }, */
  // not in use
  /* clearRecommendedCoursesStoreData (state) {
    state.recommendedCourses = []
  } */
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/cards.js